import { render, staticRenderFns } from "./C_App_SplashScreen.vue?vue&type=template&id=cd7df462&scoped=true&"
import script from "./C_App_SplashScreen.vue?vue&type=script&lang=js&"
export * from "./C_App_SplashScreen.vue?vue&type=script&lang=js&"
import style0 from "./C_App_SplashScreen.vue?vue&type=style&index=0&id=cd7df462&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7df462",
  null
  
)

export default component.exports